import { Link } from "@StarberryUtils";
import PropTypes from "prop-types";
import React,{useEffect, useState} from "react";
import {Col, Row, Container } from 'react-bootstrap';
import VideoCard from '../VideoCard/VideoCard';
import  "./OfficeNumbers.scss";
import profImg3 from "../../../images/profile-img03.png"
import Counter from '../Counter/number-counter';

import ReactMarkdown from "react-markdown"

import { inViewOptions } from '../../utils/animations';
// import { motion } from "framer-motion";
// import { InView } from "react-intersection-observer";

const containerVariants = {
  hidden: {
    opacity: 0,
    y: 60,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      ease: [0.33, 1, 0.68, 1],
      duration: 0.4
    }
  }
}

  const OfficeNumbers=(props)=>{

  return(
      <>
        <section
          className={`${props.class === "landing-page" ? 'landing-page-numbers office-numbers data' : 'office-numbers data'}`}
        >
          <Container>
            {/* <Row>
              <Col md={12}>
                  <h2 className="sec-title d-xl-none">East Finchley Office in Numbers</h2>
                  <h2 className="sec-title d-none d-xl-block">What's happening in the Mill Hill market?</h2>
                  <div className="detail d-md-flex justify-content-between">
                      <p className="desc d-xl-none">Want to view all the data and analysis on how the local property market is performing today? <Link to="#">Download Report</Link></p>
                      <p className="desc d-none d-xl-block">Integer quis massa euismod, odio eu tincidunt mauris. Want to view all the data and analysis on how the local property market is performing today? <Link to="#">Download Report</Link></p>
                      <div className="profile-item d-flex align-items-center">
                          <span className="profile-img">
                              <img loading="lazy" src={profImg3} alt="Image"/>
                              <Link to="#" className="play-icn"><i className="icon-Play-white"></i></Link>
                          </span>
                          <div className="info">
                              <p className="pro-post"><Link to="#">Watch</Link> the managers sales market report.</p>
                          </div>
                  </div>
                  </div>
              </Col>
            </Row> */}

            <Row>
              {props.data.map((item, i) => {
              let sym = item.Count[item.Count.length -1]
              let symbol = ''
              if(isNaN(sym))
              {
                symbol = sym
              }
              else
              {
                symbol = ''
              }
              let decimal = 0
              if(item.Count.indexOf('.') !== -1) {
                decimal = 1
              }
              let start = ''
              if(item.Count.indexOf('£') !== -1) {
                start = "yes"
              }

                return (
                  <Col md={6} xl={3} key={i}>
                      <strong className="numbers">
                      {start == "yes" ? '£' : ''}
                      <Counter
                            start={item.Count.replace("%",'').replace("£",'').replace("m",'')}
                            sym={symbol}
                            duration={5}
                            decimal={decimal}
                            />
                            </strong>
                      <ReactMarkdown source={item.Content ? item.Content : ''} allowDangerousHtml className="numbers_p"/>
                  </Col>
                )
              })}
            </Row>
          </Container>
        </section>
      </>
  )
}

export default OfficeNumbers
